import Tables from 'src/class/Tables';
import Formatter from 'src/class/Formatter';
import UnitPriceErrorFormatter from './UnitPriceErrorFormatter';
import SubTotalErrorFormatter from './SubTotalErrorFormatter';
import IncrementRateFormatter from './IncrementRateFormatter';
import i18n from 'src/i18n';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'date_save',
      label: i18n.t('common_words.date'),
      minWidth: 150,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'worker.code',
      label: i18n.t('common_words.code'),
      sortable: true,
      minWidth: 100,
      align: 'center',
    },
    {
      prop: 'fullName',
      label: i18n.t('labor.worker'),
      minWidth: 180,
      sortable: true,
      formatter: (row) => `${row.worker.first_name} ${row.worker.last_name}`,
    },
    {
      prop: 'farm.name',
      label: i18n.t('common_words.farm'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'lot.name',
      label: i18n.t('common_words.allotment'),
      minWidth: 80,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'activity.name',
      label: i18n.t('common_words.activity'),
      minWidth: 150,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'activity.code',
      label: i18n.t('common_words.activity_code'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'quantity',
      label: i18n.t('common_words.quantity'),
      minWidth: 80,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'activity.unit_payment_name',
      label: i18n.t('labor.unit'),
      minWidth: 80,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'number_hours',
      label: i18n.t('labor.hours_worked'),
      minWidth: 100,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'increment_rates',
      label: i18n.t('common_words.increments'),
      minWidth: 250,
      formatter: IncrementRateFormatter,
    },
    {
      prop: 'activity',
      label: i18n.t('labor.unitary_value'),
      minWidth: 150,
      sortable: true,
      align: 'center',
      formatter: UnitPriceErrorFormatter,
    },
    {
      prop: 'subtotal',
      label: i18n.t('common_words.sub_total'),
      minWidth: 150,
      sortable: true,
      align: 'center',
      formatter: SubTotalErrorFormatter,
    },

    {
      prop: 'time_type',
      label: i18n.t('labor.hour_type'),
      minWidth: 200,
      sortable: true,
      formatter: (row, column) => {
        const { price_format, name, price } = row[column.property];
        const pre = price_format === '$' ? price_format : '';
        const post = price_format === '%' ? price_format : '';
        let text = `${name} ${pre}${Formatter.formatNumber(
          Number(price)
        )}${post} adicional`;

        return text;
      },
    },
    {
      prop: 'observations',
      label: i18n.t('common_words.observation'),
      minWidth: 200,
      sortable: true,
    },
  ];

  return { Table };
};

export default configTable;
